import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { DateTime } from '../../dateTime';
import { PopoverDirective } from 'ngx-bootstrap/popover';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { SportService } from '../services/sport.service';
import { ToastrService } from 'ngx-toastr';
import { CookieService } from 'ngx-cookie-service';
import { SocketServiceService } from '../services/socket-service.service';
import { ReportService } from '../services/report.service';
import { MatPaginator } from '@angular/material/paginator';
// import { DatePipe } from '@angular/common';
import { MatTableDataSource } from '@angular/material/table';
export interface PeriodicElement {
  events: string;
  number: number;
  selection: string;
  odds: string;
  rate: string;
  stake: string;
  date: string;
}
export interface PeriodicElement1 {
  events: string;
  number: number;
  selection: string;
  odds: string;
  rate: string;
  stake: string;
  date: string;
  profit: number;
  loss: number;
  commission: number;
  total: number;
  status: string;
}
export interface IStatements {
  number: number;
  date: string;
  description: string;
  credit: string;
  debit: string;
  remark: string;
}
export interface IprofitLoss {
  date: string;
  events: string;
  total: string;
}

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit, AfterViewInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild('startpopoverRef') private _startpopoverRef: PopoverDirective;
  @ViewChild('endpopoverRef') private _endpopoverRef: PopoverDirective;
  time: Date;
  date: Date;
  endDate: Date;
  endTime: Date;
  timeSettled: Date;
  dateSettled: Date;
  endDateSettled: Date;
  endTimeSettled: Date;
  timeStatement: Date;
  dateStatement: Date;
  endDateStatement: Date;
  endTimeStatement: Date;
  timeProfit: Date;
  dateProfit: Date;
  endDateProfit: Date;
  endTimeProfit: Date;
  isDateVisible: boolean = true;
  isMeridian: boolean = false;
  openStartDate = new Date();
  openEndDate = new Date();
  settledStartDate = new Date()
  settledEndDate = new Date()
  statementStartDate = new Date()
  statementEndDate = new Date()
  gameStartDate = new Date()
  gameEndDate = new Date()
  profitStartDate = new Date()
  profitEndDate = new Date()
  displayedColumns: string[] = ['number','date', 'sport_name', 'events', 'selection', 'odds', 'stake', 'pl'];
  settledBetdisplayedColumns: string[] = ['number','date', 'sport_name', 'events', 'selection', 'odds', 'stake', 'profit','result'];
  matchdisplayedColumns: string[] = ['number', 'events', 'selection', 'odds', 'rate', 'stake', 'date']
  statementsdisplayedColumns: string[] = ['number','date','credit', 'debit', 'balance','remark', 'description' ]
  profitAndLossdisplayedColumns: string[] = ['number','result_date', 'sport_name', 'match_name', 'user_pl', 'user_commission_pl', 'net_pl','result', 'match_id']
  dataSource: any;
  matchTabledataSource: any;
  settledBetDataSource: any;
  statementsDataSource: any;
  profitandlossDataSource: any;
  activeBetTab: string = 'openBets';
  start: Date = new Date();
  end: Date = new Date();
  // openStartDate: Date = new Date()
  // openEndDate: Date = new Date()
  // settledStartDate: Date = new Date()
  // settledEndDate: Date = new Date()
  // statementStartDate: Date = new Date()
  // statementEndDate: Date = new Date()
  // gameStartDate: Date = new Date()
  // gameEndDate: Date = new Date()
  // profitStartDate: Date = new Date()
  // profitEndDate: Date = new Date()
  showMatchTable: boolean = false
  statementType: any = [];
  selections: any = '0';
  userDetails: any
  //profit and loss variable
  userData: any;
  profitData: any;
  pl: any;
  commission: any;
  netPl: any;
  param: any;
  //statements variable
  data: any;
  isSocket: any
  // today: Date = new Date()
  startAt: Date = new Date()
  searchMatch: any
  searchUser: any
  searchMarket: any
  searchSport: any
  searchSeries: any
  SportList: any;
  SeriesList: any;
  MatchList: any;
  MarketList: any;
  totalItems: any;
  settledBetsTotalItems: any;
  statementsTotalItems: any;
  profitandLossTotalItems: any;
  openBetPageIndex: any = 0
  settledBetsPageIndex: any = 0
  statementsPageIndex: any = 0
  profitandLossPageIndex: any = 0
  statementsLength: any = 0;
  openBetsLength: any = 0;
  settledBetsLength: any = 0;
  profitDataLength: any = 0;
  initialSportList: any;
  pageSize: number = 50;
  todayDateTime:Date=new Date()
  minTime: Date = new Date()
  maxTime: Date = new Date()
  constructor(private activatedRoute: ActivatedRoute, private sport: SportService, private reportService: ReportService,
    private cookie: CookieService, private toastr: ToastrService, private socketService: SocketServiceService, private route: Router) {
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    activatedRoute.params.subscribe(val => {
      if (this.activatedRoute.snapshot.params.activeTab) {
        this.activeBetTab = this.activatedRoute.snapshot.params.activeTab
        if (this.activeBetTab == 'openBets') {
          this.openBets();
          this.getSportList('openBets');
        } else if (this.activeBetTab == 'settledBets') {
          this.settledBets();
          this.getSportList('settledBets');
        } else if (this.activeBetTab == 'profitLoss') {
          this.profitLossData()
          this.getSportList('eventsProfitLoss');
        } else if (this.activeBetTab == 'statements') {
          this.getStatement()
          //this.getSportList();
        }
      }
    });
  }

  ngAfterViewInit() {
    // this.dataSource.paginator = this.paginator;
  }

  ngOnInit(): void {
    //this.startAt.setHours(23, 59, 59)
    this.minTime.setHours(0);
    this.minTime.setMinutes(0);
    this.maxTime.setHours(23);
    this.maxTime.setMinutes(59);
    this.maxTime.setSeconds(59);
    this.todayDateTime.setHours(23, 59, 59);
    this.openStartDate.setHours(0, 0, 0, 0);
    this.openEndDate.setHours(23, 59, 59)
    this.settledStartDate.setHours(0, 0, 0, 0);
    this.settledEndDate.setHours(23, 59, 59)
    this.statementStartDate.setHours(0, 0, 0, 0);
    this.statementEndDate.setHours(23, 59, 59)
    this.gameStartDate.setHours(0, 0, 0, 0);
    this.gameEndDate.setHours(23, 59, 59)
    this.profitStartDate.setHours(0, 0, 0, 0);
    this.profitEndDate.setHours(23, 59, 59)
    this.statementType = {
      '0': 'Statement',
      '1': 'Free Chips',
      '4': 'Settlement',
      '2': 'Profit Loss',
      '3': 'Commission'
    };
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.isSocket = this.cookie.get('is_socket');

    // date picker function
    if (this.openStartDate) {
      this.time = this.date = this.openStartDate;
      return;
    }
    if (this.settledStartDate) {
      this.time = this.date = this.settledStartDate;
      return;
    }
    if (this.statementStartDate) {
      this.time = this.date = this.statementStartDate;
      return;
    }
    if (this.profitStartDate) {
      this.time = this.date = this.profitStartDate;
      return;
    }

    if (this.openEndDate) {
      this.time = this.date = this.openEndDate;
      return;
    }
    if (this.settledEndDate) {
      this.time = this.date = this.settledEndDate;
      return;
    }
    if (this.statementEndDate) {
      this.time = this.date = this.statementEndDate;
      return;
    }
    if (this.profitEndDate) {
      this.time = this.date = this.profitEndDate;
      return;
    }
    this.date = this.time = new Date();
  }


  showSubMatchTable() {
    this.showMatchTable = true
  }

  //profit and loss tab table related code 

  profitLossData(event?: any, from?: string) {
    let page = event == undefined ? 1 : event.pageIndex + 1
    this.pageSize = event == undefined ? 50 : event.pageSize
    this.userData = JSON.parse(localStorage.getItem('userDetails'))
    let data = {
      // user_id: this.userData `.user_id,// OPTIONAL,
      limit: this.pageSize, // OPTIONAL min 50 max 1000,
      page: page, // OPTIONAL,
      // search: { 
      //    sport_name: ,// OPTIONAL,
      //    series_name: ,// OPTIONAL,
      //    match_name: ,// OPTIONAL,
      //    match_date: ,// OPTIONAL,
      //    event_id: ,// OPTIONAL,
      //    event_name: ,// OPTIONAL,
      //    type:, // OPTIONAL (1,2) 1=Market, 2=Fancy,

      // }
    };
    if (from == 'filterBtnClick') {
     
      if (this.profitStartDate) {
        data["from_date"] = this.profitStartDate.toISOString()
      }
      if (this.profitEndDate) {
        data["to_date"] = this.profitEndDate.toISOString()
      }
    }
    this.sport.profitLoss(data).subscribe((res) => {
      if (res.status == true) {
        this.toastr.success("Success", '', {
          positionClass: 'toast-top-center',
          timeOut: 2000
        });
        this.profitData = res.data.data;
        this.profitDataLength = res.data.data.length
        this.profitData = this.profitData.sort((a, b) => <any>new Date(b.result_date) - <any>new Date(a.result_date));
        this.profitandlossDataSource = res.data.data;
        this.profitandLossTotalItems = res.data.metadata[0].total;
        this.profitandLossPageIndex = res.data.metadata[0].page - 1;

        this.pl = this.profitData.reduce(
          (a: number, b) => a + b.p_l, 0);
        this.commission = this.profitData.reduce(
          (a: number, b) => a + b.commission, 0);
        this.netPl = this.profitData.reduce(
          (a: number, b) => a + b.net_pl, 0);
       
      } else {
        this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 5000
        })
        
      }
    })
  }


  //statements tab related code
  getStatement(event?: any, from?: string) {
    let page = event == undefined ? 1 : event.pageIndex + 1
    this.pageSize = event == undefined ? 50 : event.pageSize
    this.data = {
      "statement_type": this.selections,
      "user_id": this.userDetails.user_id,
      "limit": this.pageSize,
      "page": page,

    }
    if (this.data.statement_type == undefined || this.data.statement_type == null || this.data.statement_type == 0) {
      delete this.data.statement_type;
    }
    if (from == 'filterBtnClick') {
    
      if (this.statementStartDate) {
        this.data["from_date"] = this.statementStartDate.toISOString()
      }
      if (this.statementEndDate) {
        this.data["to_date"] = this.statementEndDate.toISOString()
      }
    }
    if (this.isSocket != 1) {

      this.reportService.statements(this.data).subscribe(data => {

        if (data.status == true) {
          this.statementsLength = data.data[0].data.length
          this.statementsDataSource = data.data[0].data;
          this.statementsTotalItems = data.data[0].metadata[0].total;
          this.statementsPageIndex = data.data[0].metadata[0].page - 1;

          // this.toastr.success(data.msg,'',{
          // positionClass: 'toast-top-center',
          //   timeOut:1000
          //  });
        } else {
          this.toastr.error(data.msg, '', {
            positionClass: 'toast-top-center',
            timeOut: 5000
          });
        }
      })
    }
    else {

      this.socketEmitEvent('account-satement', this.data);

    }

  }

  socketEmitEvent(eventName, data) {
    this.socketService.socket.emit(eventName, data);
  }

  onClickViewBets(matchId, marketId, type) {
    this.route.navigate(['/my-bet/' + matchId + '/' + marketId + '/' + type])
  }
  onSelectionChange(data) {
    this.selections = data;
    if (this.selections == '3' || this.selections == '2') {
      this.statementsdisplayedColumns = ['number','date', 'description', 'credit', 'debit']
    } else if (this.selections == '0') {
      this.statementsdisplayedColumns = ['number','date', 'description', 'credit', 'debit', 'balance']
    } else {
      this.statementsdisplayedColumns = ['number','date', 'description', 'credit', 'debit', 'balance', 'remark']
    }
    this.getStatement()
  }

  openBets(event?: any, from?: string) {
    this.pageSize = event == undefined ? 50 : event.pageSize
    let page = event == undefined ? 1 : event.pageIndex + 1
    let data = {
      page: page,
      limit: this.pageSize,
      search: {
        // "delete_status":0
      }
    }
    if (from == 'filterBtnClick') {
      if (this.openStartDate) {
        data["from_date"] = this.openStartDate.toISOString()
      }
      if (this.openEndDate) {
        data["to_date"] = this.openEndDate.toISOString()
      }
    }
    this.reportService.openBets(data).subscribe((res) => {
      if (res.status) {
        this.toastr.success("Success", '', {
          positionClass: 'toast-top-center',
          timeOut: 2000
        });
if(res.data[0].data){
  this.dataSource = res.data[0].data;
  this.openBetsLength = res.data[0].data.length;
  this.totalItems = res.data[0].metadata[0].total;
  this.openBetPageIndex = res.data[0].metadata[0].page - 1;
}
       

      } else {
       this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 5000
        });
      }
    })
  }
  settledBets(event?: any, from?: string) {
    let page = event == undefined ? 1 : event.pageIndex + 1
    this.pageSize = event == undefined ? 50 : event.pageSize
    let data = {
      "limit": this.pageSize,
      "page": page,
      search: {
        // "delete_status":0
      }
    }
    if (from == 'filterBtnClick') {
      if (this.settledStartDate) {
        data["from_date"] = this.settledStartDate.toISOString()
      }
      if (this.settledEndDate) {
        data["to_date"] = this.settledEndDate.toISOString()
      }
    }
    this.reportService.settleBets(data).subscribe((res) => {
      if (res.status) {
        this.toastr.success("Success", '', {
          positionClass: 'toast-top-center',
          timeOut: 2000
        });
        this.settledBetDataSource = res.data[0].data;
        this.settledBetsLength = res.data[0].data.length;
        this.settledBetsTotalItems = res.data[0].metadata[0].total;
        this.settledBetsPageIndex = res.data[0].metadata[0].page - 1;

      } else {
       this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 5000
        });
      }
    })
  }

  tabClick(tabname) {
    this.userDetails = JSON.parse(localStorage.getItem('userDetails'));
    this.activeBetTab = tabname
    this.searchSport = undefined
    this.searchMatch = undefined
    this.searchUser = undefined
    this.searchMarket = undefined
    this.searchSeries = undefined
    if (this.activeBetTab == 'openBets') {
      this.openBets();
      this.getSportList('openBets');
    } else if (this.activeBetTab == 'settledBets') {
      this.settledBets();
      this.getSportList('settledBets');
    } else if (this.activeBetTab == 'profitLoss') {
      this.profitLossData()
      this.getSportList('eventsProfitLoss');
    } else if (this.activeBetTab == 'statements') {
      this.getStatement()
    }
   
  }

  getSportList(type) {
    let data = {
      type: type,
      search: {}
    };
    this.reportService.eventList(data).subscribe((res) => {
      if (res.status == true) {
        this.initialSportList = res.data[0]
        this.SportList = res.data[0].sports;
        this.SeriesList = res.data[0].series;
        this.MatchList = res.data[0].matches;
        this.MarketList = res.data[0].events_m_f;
      } else {
       this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 5000
        });
      }
    })
  }

  filterProfitLossData(searchData, type, from?: string) {
    this.userData = JSON.parse(localStorage.getItem('userDetails'))
    let data;
    if (type == 0) {

      data = {
        limit: this.pageSize, // OPTIONAL min 50 max 1000,
        page: 1, // OPTIONAL,
        "search": {
          "sport_name": searchData
        }
      }
    } else if (type == 1) {

      data = {
        limit: this.pageSize, // OPTIONAL min 50 max 1000,
        page: 1, // OPTIONAL,
        "search": {
          "series_name": searchData,
        }
      }
      if(this.searchSport){
        data.search['sport_name']=this.searchSport.sport_name
      }
    } else if( type == 2){
      data = {
        limit: this.pageSize, // OPTIONAL min 50 max 1000,
        page: 1, // OPTIONAL,
        "search": {
          "match_name": searchData
        }
      }
      if(this.searchSport){
        data.search['sport_name']=this.searchSport.sport_name
      }
      if(this.searchSeries){
        data.search['series_name']=this.searchSeries.series_name
      }
    } else if( type == 3){
      data = {
        limit: this.pageSize, // OPTIONAL min 50 max 1000,
        page: 1, // OPTIONAL,
        "search": {
          // "event_name": searchData,
          "event_id": searchData,
          "type": 1
        }
      }
      if(this.searchSport){
        data.search['sport_name']=this.searchSport.sport_name
      }
      if(this.searchSeries){
        data.search['series_name']=this.searchSeries.series_name
      }
      if(this.searchMatch){
        data.search['match_name']=this.searchMatch.match_name
      }
    } else if( type == 4){
      data = {
        limit: this.pageSize, // OPTIONAL min 50 max 1000,
        page: 1, // OPTIONAL,
        "search": {
          // "event_name": searchData,
          "event_id": searchData,
          "type": 2
        }
      }
      if(this.searchSport){
        this.param.search['sport_id']=this.searchSport.sport_id
      }
      if(this.searchSeries){
        this.param.search['series_name']=this.searchSeries.series_name
      }
      if(this.searchMatch){
        this.param.search['match_name']=this.searchMatch.match_name
      }
    }

    if (from == 'filterBtnClick') {
      data = {
        limit: this.pageSize, // OPTIONAL min 50 max 1000,
        page: 1, // OPTIONAL,
        "search": {
          "sport_name": this.searchSport,
          "series_name": this.searchSeries,
          "match_name": this.searchMatch
        }
      }
      if (this.profitStartDate) {
        data["from_date"] = this.profitStartDate.toISOString()
      }
      if (this.profitEndDate) {
        data["to_date"] = this.profitEndDate.toISOString()
      }
    }

    this.sport.profitLoss(data).subscribe((res) => {
      if (res.status == true) {
        this.toastr.success("Success", '', {
          positionClass: 'toast-top-center',
          timeOut: 2000
        });
        this.profitData = res.data.data;
        this.profitData = this.profitData.sort((a, b) => <any>new Date(b.result_date) - <any>new Date(a.result_date));
        this.profitandlossDataSource = res.data.data;
        this.pl = this.profitData.reduce(
          (a: number, b) => a + b.p_l, 0);
        this.commission = this.profitData.reduce(
          (a: number, b) => a + b.commission, 0);
        this.netPl = this.profitData.reduce(
          (a: number, b) => a + b.net_pl, 0);
      } else {
        this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 10000,
        })
      }
    })
  }
  getProfitLossFilterData(type, id, name) {
    if (type == 0) {

      this.param = {
        "search": {
          "sport_id": id
        }
      }
    //  this.searchSport=name
     
      this.searchMatch=undefined
      this.searchMarket=undefined
      this.searchSeries=undefined
      this.filterProfitLossData(name,type);
    } else if( type == 1){

      this.param = {
        "search": {
          "series_id": id,
        }
      }
      //this.searchSeries=name
      this.searchMatch=undefined
      this.searchMarket=undefined
      
      this.filterProfitLossData(name,type);
    } else if( type == 2){

      this.param = {
        "search": {
          "match_id": id
        }
      }
    
      //this.searchMatch=name
      this.searchMarket=undefined
    
      this.filterProfitLossData(name,type);
    } 
    // else if( type == 3){
    //   this.param = {
    //     "search": {
    //       "market_id": id
    //     }
    //   }
    // } else if( type == 4){
    //   this.param = {
    //     "search": {
    //       "fancy_id": id
    //     }
    //   }
    // }
    this.param['type']='eventsProfitLoss'
    this.reportService.eventList(this.param).subscribe((res) => {
      if (res.status == true) {
        this.initialSportList = res.data[0]
        if (type == 0) {
          this.SeriesList = res.data[0].series;
          this.MatchList = res.data[0].matches;
          this.MarketList = res.data[0].events_m_f;
        } else if (type == 1) {
          this.MatchList = res.data[0].matches;
          this.MarketList = res.data[0].events_m_f;
        } else if (type == 2) {
          this.MarketList = res.data[0].events_m_f;
        }
        // this.SportList = res.data[0].sports;
        // this.SeriesList = res.data[0].series;
        // this.MatchList = res.data[0].matches;
        // this.MarketList = res.data[0].events_m_f;
      } else {
       this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 5000
        });
      }
    })
  }

  getOpenBetFilterData(type, id, name) {
    if (type == 0) {
      this.param = {
        "search": {
          "sport_id": id
        }
      }

      this.searchMatch = undefined
      this.searchMarket = undefined
      this.searchSeries = undefined
      //this.searchSport = name

    } else if (type == 1) {
      this.param = {
        "search": {
          "series_id": id,
        }
      }

      this.searchMatch = undefined
      this.searchMarket = undefined
      if(this.searchSport){
        this.param.search['sport_id']=this.searchSport.sport_id
      }
     // this.searchSeries = name

    } else if (type == 2) {

      this.param = {
        "search": {
          "match_id": id
        }
      }

      this.searchMarket = undefined
     // this.searchMatch = name
     if(this.searchSport){
      this.param.search['sport_id']=this.searchSport.sport_id
    }
    if(this.searchSeries){
      this.param.search['series_id']=this.searchSeries.series_id
    }
    } else if (type == 3) {

      this.param = {

        "search": {
          // "event_name": searchData,
          "market_id": id,
          "type": 1
        }
      }
      if(this.searchSport){
        this.param.search['sport_id']=this.searchSport.sport_id
      }
      if(this.searchSeries){
        this.param.search['series_id']=this.searchSeries.series_id
      }
      if(this.searchMatch){
        this.param.search['match_id']=this.searchMatch.match_id
      }


     // this.searchMarket = name
    } else if (type == 4) {
      this.param = {

        "search": {
          // "event_name": searchData,
          "fancy_id": id,
          "type": 2
        }
      }
      if(this.searchSport){
        this.param.search['sport_id']=this.searchSport.sport_id
      }
      if(this.searchSeries){
        this.param.search['series_id']=this.searchSeries.series_id
      }
      if(this.searchMatch){
        this.param.search['match_id']=this.searchMatch.match_id
      }
      //this.searchMarket = name
    }

    this.param["page"] = 1
    this.param["limit"] = this.pageSize
    this.filterSearchDropdownValues(this.param.search, type,'openBets')
    this.reportService.openBets(this.param).subscribe((res) => {
      if (res.status) {
        this.toastr.success("Success", '', {
          positionClass: 'toast-top-center',
          timeOut: 2000
        });
        this.dataSource = res.data[0].data;

        this.totalItems = res.data[0].metadata[0].total;
        this.openBetPageIndex = res.data[0].metadata[0].page - 1;

      } else {
       this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 5000
        });
      }
    })

  }

  getSettledBetFilterData(type, id, name) {
    if (type == 0) {
      this.param = {
        "search": {
          "sport_id": id
        }
      }
      //this.searchSport = name
      this.searchMatch = undefined
      this.searchMarket = undefined
      this.searchSeries = undefined
    } else if (type == 1) {

      this.param = {
        "search": {
          "series_id": id,
        }
      }
      //this.searchSeries = name
      this.searchMatch = undefined
      this.searchMarket = undefined
      if(this.searchSport){
        this.param.search['sport_id']=this.searchSport.sport_id
      }
    } else if (type == 2) {

      this.param = {
        "search": {
          "match_id": id
        }
      }
      //this.searchMatch = name

      this.searchMarket = undefined
      if(this.searchSport){
        this.param.search['sport_id']=this.searchSport.sport_id
      }
      if(this.searchSeries){
        this.param.search['series_id']=this.searchSeries.series_id
      }
    } else if (type == 3) {
      this.param = {

        "search": {
          // "event_name": searchData,
          "market_id": id,
          "type": 1
        }
      }
      if(this.searchSport){
        this.param.search['sport_id']=this.searchSport.sport_id
      }
      if(this.searchSeries){
        this.param.search['series_id']=this.searchSeries.series_id
      }
      if(this.searchMatch){
        this.param.search['match_id']=this.searchMatch.match_id
      }
    } else if (type == 4) {
      this.param = {

        "search": {
          // "event_name": searchData,
          "fancy_id": id,
          "type": 2
        }
      }
      if(this.searchSport){
        this.param.search['sport_id']=this.searchSport.sport_id
      }
      if(this.searchSeries){
        this.param.search['series_id']=this.searchSeries.series_id
      }
      if(this.searchMatch){
        this.param.search['match_id']=this.searchMatch.match_id
      }
    }
    this.param["page"] = 1
    this.param["limit"] = this.pageSize
    this.filterSearchDropdownValues(this.param.search, type,'settledBets')
    this.reportService.settleBets(this.param).subscribe((res) => {
      if (res.status) {
        this.toastr.success("Success", '', {
          positionClass: 'toast-top-center',
          timeOut: 2000
        });
        this.settledBetDataSource = res.data[0].data;
        this.settledBetsTotalItems = res.data[0].metadata[0].total;
        this.settledBetsPageIndex = res.data[0].metadata[0].page - 1;

      } else {
       this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 5000
        });
      }
    })

  }

  filterSearchDropdownValues(search, type,typeParamenterValue) {
    let listParams = {
      type:typeParamenterValue,
      search: search
    }
    delete listParams.search.type
    this.reportService.eventList(listParams).subscribe((res) => {
      if (res.status == true) {
        if (type == 0) {
          this.SeriesList = res.data[0].series;
          this.MatchList = res.data[0].matches;
          this.MarketList = res.data[0].events_m_f;
        } else if (type == 1) {
          this.MatchList = res.data[0].matches;
          this.MarketList = res.data[0].events_m_f;
        } else if (type == 2) {
          this.MarketList = res.data[0].events_m_f;
        }

      } else {
       this.toastr.error(res.msg, '', {
          positionClass: 'toast-top-center',
          timeOut: 5000
        });
      }
    })
  }

  onClickClear() {
    this.searchSport = undefined
    this.searchMatch = undefined
    this.searchMarket = undefined
    this.searchSeries = undefined
    this.param = undefined
    
    this.gameStartDate.setHours(0, 0, 0, 0);
    this.gameEndDate.setHours(23, 59, 59)
   
    // if (this.activeBetTab == 'openBets') {
    //   this.openBets();
    // } else if (this.activeBetTab == 'settledBets') {
    //   this.settledBets();
    // } else if (this.activeBetTab == 'profitLoss') {
    //   this.profitLossData()
    // } else if (this.activeBetTab == 'statements') {
    //   this.getStatement()
    // }
    if (this.activeBetTab == 'openBets') {
      this.openBets();
      this.getSportList('openBets');
      this.openStartDate=new Date()
      this.openEndDate=new Date()
      this.openStartDate.setHours(0, 0, 0, 0);
    this.openEndDate.setHours(23, 59, 59)
    } else if (this.activeBetTab == 'settledBets') {
      this.settledBets();
      this.settledStartDate=new Date()
      this.settledEndDate=new Date()
      this.settledStartDate.setHours(0, 0, 0, 0);
      this.settledEndDate.setHours(23, 59, 59)
      this.getSportList('settledBets');
    } else if (this.activeBetTab == 'profitLoss') {
      this.profitLossData()
      this.profitStartDate=new Date()
      this.profitEndDate=new Date()
      this.getSportList('eventsProfitLoss');
      this.profitStartDate.setHours(0, 0, 0, 0);
      this.profitEndDate.setHours(23, 59, 59)
    } else if (this.activeBetTab == 'statements') {
      this.getStatement()
      this.statementStartDate=new Date()
      this.statementEndDate=new Date()
      this.statementStartDate.setHours(0, 0, 0, 0);
    this.statementEndDate.setHours(23, 59, 59)
      //this.getSportList();
    }

    // date picker 
   
  }

  clear(){
    this.time = void 0;
    this.date = void 0;
    this.openStartDate = void 0;
    this.openEndDate = void 0;
    this.settledStartDate = void 0;
    this.settledEndDate = void 0;
    this.statementStartDate = void 0;
    this.statementEndDate = void 0;
    this.profitStartDate = void 0;
    this.profitEndDate = void 0;
  }

  getTotalPL() {
    if (this.activeBetTab == 'profitLoss') {
      return this.profitandlossDataSource.map(t => t.user_pl).reduce((acc, value) => acc + value, 0);
    }
  }
  getTotalCommission() {
    if (this.activeBetTab == 'profitLoss') {
      return this.profitandlossDataSource.map(t => t.user_commission_pl).reduce((acc, value) => acc + value, 0);
    }
  }
  getTotalNetPl() {
    if (this.activeBetTab == 'profitLoss') {
      return this.profitandlossDataSource.map(t => t.net_pl).reduce((acc, value) => acc + value, 0);
    }
  }
  getTotalStatementBalance() {
    if (this.activeBetTab == 'statements') {
      return this.statementsDataSource.map(t => t.balance).reduce((acc, value) => acc + value, 0);
    }
  }
  getTotalCredits() {
    if (this.activeBetTab == 'statements') {
      return this.statementsDataSource.filter(({ credit_debit }) => credit_debit >= 0).map(t => t.credit_debit).reduce((acc, value) => acc + value, 0);
    }

  }
  getTotalDebits() {
    if (this.activeBetTab == 'statements') {
      return this.statementsDataSource.filter(({ credit_debit }) => 0 > credit_debit).map(t => t.credit_debit).reduce((acc, value) => acc + value, 0);
    }
  }
  
  // date time picker
  @ViewChild('popoverRef') private _popoverRef: PopoverDirective;
  // time: Date;
  // date: Date;
  // isDateVisible: boolean = true;
  // isMeridian: boolean = false;
  dateTime = new Date();

  dateSelectionDone() {
    this.isDateVisible = false;
  }

  updateDate() {

    if (this.date) {
      this.openStartDate = DateTime.getDateTime(this.date, this.time);
    }
    if (!this.time) {
      this.time = this.date;
    }
  }
  updateDateSettled() {
    if (this.dateSettled) {
      this.settledStartDate = DateTime.getDateTime(this.dateSettled, this.timeSettled);
    }
    if (!this.timeSettled) {
      this.timeSettled = this.dateSettled;
    }
  }
  updateDateStatement() {
    if (this.dateStatement) {
      this.statementStartDate = DateTime.getDateTime(this.dateStatement, this.timeStatement);
    }
    if (!this.timeStatement) {
      this.timeStatement = this.dateStatement;
    }
  }
  updateDateProfit() {
    if (this.dateProfit) {
      this.profitStartDate = DateTime.getDateTime(this.dateProfit, this.timeProfit);
    }
    if (!this.timeProfit) {
      this.timeProfit = this.dateProfit;
    }
  }

  updateEndDate() {

    if (this.endDate) {
      this.openEndDate = DateTime.getDateTime(this.endDate, this.endTime);
    }
    if (!this.endTime) {
      this.endTime = this.endDate;
    }
  }
  updateEndDateSettled() {
    if (this.endDateSettled) {
      this.settledEndDate = DateTime.getDateTime(this.endDateSettled, this.endTimeSettled);
    }
    if (!this.endTimeSettled) {
      this.endTimeSettled = this.endDateSettled;
    }
  }
  updateEndDateStatement() {
    if (this.endDateStatement) {
      this.statementEndDate = DateTime.getDateTime(this.endDateStatement, this.endTimeStatement);
    }
    if (!this.endTimeStatement) {
      this.endTimeStatement = this.endDateStatement;
    }
  }
  updateEndDateProfit() {
    if (this.endDateProfit) {
      this.profitEndDate = DateTime.getDateTime(this.endDateProfit, this.endTimeProfit);
    }
    if (!this.endTimeProfit) {
      this.endTimeProfit = this.endDateProfit;
    }
  }

  updateTime() {
    if (this.time) {
      this.openStartDate = DateTime.getDateTime(this.date, this.time);
    }
  }
  updateTimeSettled() {
    if (this.timeSettled) {
      this.settledStartDate = DateTime.getDateTime(this.dateSettled, this.timeSettled);
    }
  }
  updateTimeStatement() {
    if (this.timeStatement) {
      this.statementStartDate = DateTime.getDateTime(this.dateStatement, this.timeStatement);
    }
  }
  updateTimeProfit() {
    if (this.timeProfit) {
      this.profitStartDate = DateTime.getDateTime(this.dateProfit, this.timeProfit);
    }
  }
  updateEndTime() {
    if (this.endTime) {
      this.openEndDate = DateTime.getDateTime(this.endDate, this.endTime);
    }
  }
  updateEndTimeSettled() {
    if (this.endTime) {
      this.settledEndDate = DateTime.getDateTime(this.endDateSettled, this.endTimeSettled);
    }
  }
  updateEndTimeStatement() {
    if (this.endTime) {
      this.statementEndDate = DateTime.getDateTime(this.endDateStatement, this.endTimeStatement);
    }
  }
  updateEndTimeProfit() {
    if (this.endTime) {
      this.profitEndDate = DateTime.getDateTime(this.endDateProfit, this.endTimeProfit);
    }
  }


  showDate() {
    this.isDateVisible = true;
  }

  showTime() {
    this.isDateVisible = false;
  }

  close() {
    this._startpopoverRef.hide();

  }
  closeEndDatepicker() {
    this._endpopoverRef.hide()
  }
  // now() {
  //   this.openStartDate = DateTime.now(this.date);
  //   this.time = this.openStartDate;
  //   this.openEndDate = DateTime.now(this.date);
  //   this.time = this.openEndDate;

  //   this.settledStartDate = DateTime.now(this.date);
  //   this.time = this.settledStartDate;
  //   this.settledEndDate = DateTime.now(this.date);
  //   this.time = this.settledEndDate;

  //   this.statementStartDate = DateTime.now(this.date);
  //   this.time = this.statementStartDate;
  //   this.statementEndDate = DateTime.now(this.date);
  //   this.time = this.statementEndDate;

  //   this.profitStartDate = DateTime.now(this.date);
  //   this.time = this.profitStartDate;
  //   this.profitEndDate = DateTime.now(this.date);
  //   this.time = this.profitEndDate;
  // }

  today() {
    this.date = this.time = new Date();
    this.openStartDate = DateTime.now(this.date);
    this.openEndDate = DateTime.now(this.date);
    
    this.settledStartDate = DateTime.now(this.date);
    this.settledEndDate = DateTime.now(this.date);

    this.statementStartDate = DateTime.now(this.date);
    this.statementEndDate = DateTime.now(this.date);
    
    this.profitStartDate = DateTime.now(this.date);
    this.profitEndDate = DateTime.now(this.date);
  }
}

